import { textStyles } from "../../../../../shared/theme/fonts-ppv";

export default {
  statusWrapper: {
    paddingLeft: 14
  },
  addBranchText: {
    paddingLeft: 20,
    color: '#4B2885',
    cursor: 'pointer',
    ...textStyles.subtitle2
  },
  addBranchTextInner: {
    textDecoration: 'underline'
  }
};
